let runtime = null;

export let DEBUG_MAP = false;
export let DEBUG_MODE = false;
export let debugPanel = { hidden: true };
export let state = {};

export function setMapRuntime(nextRuntime) {
  runtime = nextRuntime;
  state = nextRuntime.state;
  DEBUG_MAP = Boolean(nextRuntime.DEBUG_MAP);
  DEBUG_MODE = Boolean(nextRuntime.DEBUG_MODE);
  debugPanel = nextRuntime.debugPanel || { hidden: true };
}

function currentRuntime() {
  if (!runtime) {
    throw new Error("Map runtime has not been initialized.");
  }
  return runtime;
}

export function apiOrigin() {
  return currentRuntime().apiOrigin();
}

export function copy(key) {
  return currentRuntime().copy(key);
}

export function escapeHtml(value) {
  return currentRuntime().escapeHtml(value);
}

export function formatCopy(key, replacements = {}) {
  return currentRuntime().formatCopy(key, replacements);
}

export function countCopy(oneKey, manyKey, count, replacements = {}) {
  return currentRuntime().countCopy(oneKey, manyKey, count, replacements);
}

export function language() {
  return currentRuntime().language();
}

export function renderCommunityReportCount() {
  return currentRuntime().renderCommunityReportCount();
}
